import React from "react";
import "./Footer.css";

const Footer = () => {
  const quickLinks = [
    { text: "ABOUT US", url: "/AboutUs" },
    { text: "ENGINEERING & SAFETY", url: "/Engineering&Safety" },
    { text: "PARTS & SERVICES", url: "/Parts&Services" },
    { text: " X CUBE", url: "/XCube" },
  ];

  const contacts = [
    {
      title: "Riocube Singapore",
      name: "Wilma Wang",
      email: "wilma.wang@riocube.com",
      address:
        "11 North Buona Vista Drive, #08-09 The Metropolis Tower 2, Singapore 138589",
    },
    {
      title: "Riocube China",
      name: "Woody Zhang",
      email: "wmzhang@riocube.com",
      address:
        "Youcheng Building, Chaoyang District, Beijing Jiashenghengcheng Pioneer Park, Tongzhou District, Beijing",
    },
    {
      title: "X Cube",
      name: "Sean Lim",
      email: "Sean.lim@riocube.com",
      address:
        "Building I, YuanGu Creative Park, No.689 Guanghua Road, Min Hang District, Shanghai, China",
    },
  ];

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-column">
          <h4 className="column-title">Quick Links</h4>
          <ul className="links-list">
            {quickLinks.map((link, index) => (
              <li key={index}>
                <a href={link.url} className="footer-link">
                  {link.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
        {contacts.map((contact, index) => (
          <div className="footer-column" key={index}>
            <h4 className="column-title">{contact.title}</h4>
            <div className="contact-block">
              <p className="contact-name">{contact.name}</p>
              <a href={`mailto:${contact.email}`} className="contact-email">
                {contact.email}
              </a>
              <p className="contact-address">{contact.address}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="footer-bottom">
        <div className="social-media">
          <a
            href="https://www.linkedin.com/company/9488757/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
            </svg>
          </a>
        </div>
        <p className="copyright">
          © {new Date().getFullYear()} Riocube. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
